import Button from '@material-ui/core/Button';
import CardMedia from '@material-ui/core/CardMedia';
import Paper from '@material-ui/core/Paper';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from '@material-ui/core/Typography';
import { Icon } from 'semantic-ui-react';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
  },
  url: {
    color: 'darkgrey',
    fontSize: '0.5rem !important',
  },
  title: {
    color: 'black',
  },
  main: {
    marginTop: '20px',
    fontWeight: '100',
  },
  pos: {
    color: 'darkorange',
    fontSize: '0.5rem !important',
    marginBottom: '25px',
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
    marginTop: '10px',
  },
  diffuculty: {
    fontSize: '0.5rem !important',
  },
});

// const difficultyColor = (difficulty) => {
//   if (difficulty) {
//     switch (true) {
//       case difficulty >= 8:
//         return {
//           color: 'red',
//         };
//       case difficulty >= 6 && difficulty < 8:
//         return {
//           color: 'orange',
//         };
//       default:
//         return {
//           color: 'green',
//         };
//     }
//   }
// };

const difficultyText = (difficulty) => {
  if (difficulty) {
    switch (true) {
      case difficulty >= 8:
        return 'Large';
      case difficulty >= 6 && difficulty < 8:
        return 'Medium';
      default:
        return 'Small';
    }
  }
};

function ProjectCard(props) {
  const { classes, difficulty, id, image, history, main, title, url, urlTitle, year } = props;

  return (
    <div className="col-md-12 mb-4 mt-4">
      <Paper className={classes.root} elevation={2}>
        <Typography className={classes.url} color="textSecondary" gutterBottom>
          {url || 'URL: Private'}
        </Typography>
        <Typography variant="h5" component="h2" className={classes.title}>
          {title}
        </Typography>
        <Typography className={classes.pos} color="textSecondary">
          <span>
            <Icon name="calendar alternate outline" /> {year}
          </span>
          <span className="ml-4">
            <Icon name="user" /> {difficultyText(difficulty)}
          </span>
        </Typography>
        {/*
          <Typography className={classes.difficulty}>
            <span style={difficultyColor(difficulty)}>
              Difficulty and Size: {difficulty}
              /10
            </span>
          </Typography>
        */}
        {image && <CardMedia className={classes.media} image={image} title="Paella dish" />}
        <Typography component="p" className={classes.main}>
          {main}
        </Typography>
        <div className="text-left mt-2">
          <Button
            color="primary"
            variant="contained"
            onClick={() => history.push(`/project/${id}/${urlTitle}`)}
            className="mt-2 mb-2"
          >
            More
          </Button>
        </div>
      </Paper>
    </div>
  );
}

ProjectCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

// ProjectCard = ;

export default withRouter(withStyles(styles)(ProjectCard));



// WEBPACK FOOTER //
// ./src/components/common/ProjectCard.js